export const INCIDENT_FILTER_STALE_TIME_MS = 5 * 60 * 1000;
